<div class="profile__wrapper">
  <form
    [formGroup]="personalDataForm"
    class="personal__form"
    autocomplete="off"
  >
    <i
      class="icon-pencil"
      [class.grey]="isEditable"
      (click)="switchEdit($event)"
      *ngIf="ableToEdit"
    ></i>
    <fieldset [disabled]="!isEditable" class="form__fieldset">
      <div class="form__row row">
        <div class="form__col col-6">
          <div class="form__title">location</div>
          <div class="row mb-3 location-wrapper">
            <div class="location-wrapper-item">
              <label
                class="location-label label-input white-space-nowrap"
                appMarkAsterisk
                [formGroup]="personalDataForm"
                [controlName]="'country'"
                [touched]="personalDataForm.get('country')!.touched"
                >Country
              </label>
              <div class="general_form_input location-input">
                <div
                  [class.custom-input-empty]="
                    isEditable && !personalDataForm.get('country')?.value
                  "
                  [class.custom-input-filled]="
                    isEditable && personalDataForm.get('country')?.value
                  "
                >
                  <app-dropdown
                    ngDefaultControl
                    [border]="'none'"
                    [items]="countryList"
                    formControlName="country"
                    [isEditMode]="isEditable"
                  ></app-dropdown>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('country', personalDataForm) &&
                      personalDataForm.get('country')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
            </div>
            <div class="location-wrapper-item">
              <label
                class="location-label label-input"
                appMarkAsterisk
                [formGroup]="personalDataForm"
                [controlName]="'city'"
                [touched]="personalDataForm.get('city')!.touched"
                >City
              </label>
              <div class="general_form_input location-input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="city"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('city', personalDataForm) &&
                    personalDataForm.get('city')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    personalDataForm.get('city')!.hasError('maxlength')
                  "
                  [errorMessage]="'Max field length = 20'"
                ></app-error-field>
              </div>
            </div>
          </div>
          <div class="form__title">Contacts</div>
          <ng-container formArrayName="phoneNumbers">
            <div
              *ngFor="let phone of phoneNumbersArray.controls; let i = index"
            >
              <app-messengers
                [editMode]="isEditable"
                (messengersChecked)="setPhoneNumber($event, i)"
                [phoneData]="phoneNumbersComponentData[i]"
                [personalTab]="true"
                (removePhone)="removeItem(i, phoneNumbersArray)"
              ></app-messengers>
            </div>
          </ng-container>
          <ng-container formArrayName="emails">
            <div class="row">
              <div
                *ngFor="let email of emailsArray.controls; let i = index"
                [formGroupName]="i"
              >
                <div class="row form__item">
                  <label
                    class="label-input additional__fields col-5"
                    for=""
                    appMarkAsterisk
                    [formGroup]="emailsArrayControls(i)"
                    [controlName]="'email'"
                    [touched]="emailsArrayControls(i).get('email')!.touched"
                    >Email
                  </label>
                  <div class="additional__field form__validation">
                    <input
                      type="text"
                      placeholder=" "
                      class="input__basic"
                      formControlName="email"
                    />
                    <app-error-field
                      [displayError]="
                        isFieldInvalid('email', emailsArrayControls(i)) &&
                        emailsArrayControls(i)
                          .get('email')!
                          .hasError('required')
                      "
                      [errorMessage]="'The field is required'"
                    ></app-error-field>
                    <app-error-field
                      [displayError]="
                        isFieldInvalid('email', emailsArrayControls(i)) &&
                        emailsArrayControls(i).get('email')!.hasError('pattern')
                      "
                      [errorMessage]="'Please enter a valid email'"
                    ></app-error-field>
                    <app-error-field
                      [displayError]="
                        emailsArrayControls(i)
                          .get('email')!
                          .hasError('maxlength') &&
                        !emailsArrayControls(i)
                          .get('email')!
                          .hasError('pattern')
                      "
                      [errorMessage]="'Max field length = 30'"
                    ></app-error-field>
                    <img
                      *ngIf="isEditable"
                      class="trash"
                      src="assets/icons/svg/trash/ion_trash-bin.svg"
                      alt="trash"
                      (click)="removeItem(i, emailsArray)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container formArrayName="socialNetworks">
            <div class="row">
              <div
                *ngFor="
                  let network of socialNetworksArray.controls;
                  let i = index
                "
                [formGroupName]="i"
              >
                <ng-container [ngSwitch]="network.get('type')?.value.name">
                  <ng-container *ngSwitchCase="'Facebook'">
                    <div class="row form__item">
                      <label
                        class="label-input additional__fields col-5"
                        for=""
                        appMarkAsterisk
                        [formGroup]="socialNetworksControls(i)"
                        [controlName]="'socialNetworkLink'"
                        [touched]="
                          socialNetworksControls(i).get('socialNetworkLink')!
                            .touched
                        "
                        >Facebook
                      </label>
                      <div class="additional__field form__validation">
                        <input
                          type="text"
                          placeholder=" "
                          class="input__basic"
                          formControlName="socialNetworkLink"
                        />
                        <app-error-field
                          [displayError]="
                            isFieldInvalid(
                              'socialNetworkLink',
                              socialNetworksControls(i)
                            ) &&
                            socialNetworksControls(i)
                              .get('socialNetworkLink')!
                              .hasError('required')
                          "
                          [errorMessage]="'The field is required'"
                        ></app-error-field>
                        <app-error-field
                          [displayError]="
                            socialNetworksControls(i)
                              .get('socialNetworkLink')!
                              .hasError('maxlength')
                          "
                          [errorMessage]="'Max field length = 40'"
                        ></app-error-field>
                        <img
                          *ngIf="isEditable"
                          class="trash"
                          src="assets/icons/svg/trash/ion_trash-bin.svg"
                          alt="trash"
                          (click)="removeItem(i, socialNetworksArray)"
                        />
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Skype'">
                    <div class="row form__item">
                      <label
                        class="label-input additional__fields col-5"
                        for=""
                        appMarkAsterisk
                        [formGroup]="socialNetworksControls(i)"
                        [controlName]="'socialNetworkLink'"
                        [touched]="
                          socialNetworksControls(i).get('socialNetworkLink')!
                            .touched
                        "
                        >Skype
                      </label>
                      <div class="additional__field form__validation">
                        <input
                          type="text"
                          placeholder=" "
                          class="input__basic"
                          formControlName="socialNetworkLink"
                        />
                        <app-error-field
                          [displayError]="
                            isFieldInvalid(
                              'socialNetworkLink',
                              socialNetworksControls(i)
                            ) &&
                            socialNetworksControls(i)
                              .get('socialNetworkLink')!
                              .hasError('required')
                          "
                          [errorMessage]="'The field is required'"
                        ></app-error-field>
                        <app-error-field
                          [displayError]="
                            socialNetworksControls(i)
                              .get('socialNetworkLink')!
                              .hasError('maxlength')
                          "
                          [errorMessage]="'Max field length = 40'"
                        ></app-error-field>
                        <img
                          *ngIf="isEditable"
                          class="trash"
                          src="assets/icons/svg/trash/ion_trash-bin.svg"
                          alt="trash"
                          (click)="removeItem(i, socialNetworksArray)"
                        />
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Linkedin'">
                    <div class="row form__item">
                      <label
                        class="label-input additional__fields col-5"
                        for=""
                        appMarkAsterisk
                        [formGroup]="socialNetworksControls(i)"
                        [controlName]="'socialNetworkLink'"
                        [touched]="
                          socialNetworksControls(i).get('socialNetworkLink')!
                            .touched
                        "
                        >Linkedin
                      </label>
                      <div class="additional__field form__validation">
                        <input
                          type="text"
                          placeholder=" "
                          class="input__basic"
                          formControlName="socialNetworkLink"
                        />
                        <app-error-field
                          [displayError]="
                            isFieldInvalid(
                              'socialNetworkLink',
                              socialNetworksControls(i)
                            ) &&
                            socialNetworksControls(i)
                              .get('socialNetworkLink')!
                              .hasError('required')
                          "
                          [errorMessage]="'The field is required'"
                        ></app-error-field>
                        <app-error-field
                          [displayError]="
                            socialNetworksControls(i)
                              .get('socialNetworkLink')!
                              .hasError('maxlength')
                          "
                          [errorMessage]="'Max field length = 40'"
                        ></app-error-field>
                        <img
                          *ngIf="isEditable"
                          class="trash"
                          src="assets/icons/svg/trash/ion_trash-bin.svg"
                          alt="trash"
                          (click)="removeItem(i, socialNetworksArray)"
                        />
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <div #visibleContents>
            <button
              class="button button__add--normal"
              *ngIf="isEditable"
              (click)="showFields($event)"
            ></button>
            <div class="unshown__info" *ngIf="visibleFields" [@enterAnimation]>
              <div
                class="unshown__list"
                *ngFor="let item of allItems; let i = index"
              >
                <div class="unshown__item" (click)="addColumn(i)">
                  {{ item | camelCase }}
                </div>
              </div>
            </div>
          </div>

          <div class="form__item row">
            <label
              class="label-input col-5"
              appMarkAsterisk
              [formGroup]="personalDataForm"
              [controlName]="'residenceAddress'"
              [touched]="personalDataForm.get('residenceAddress')!.touched"
              >Address of actual residence</label
            >
            <div class="input__wrapper col-sm-5">
              <input
                type="text"
                class="input__basic"
                placeholder=" "
                formControlName="residenceAddress"
              />
              <app-error-field
                [displayError]="
                  personalDataForm
                    .get('residenceAddress')!
                    .hasError('maxlength')
                "
                [errorMessage]="'Max field length = 100'"
              ></app-error-field>
            </div>
          </div>
          <div class="form__item row">
            <label
              class="label-input col-5"
              appMarkAsterisk
              [formGroup]="personalDataForm"
              [controlName]="'postOfficeAddress'"
              [touched]="personalDataForm.get('postOfficeAddress')!.touched"
              >Post office address</label
            >
            <div class="input__wrapper col-sm-5">
              <ng-container *ngIf="isEditable; else textAddress">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="postOfficeAddress"
                />
              </ng-container>
              <ng-template #textAddress>
                <span class="input__basic">{{
                  personalDataForm.get('postOfficeAddress')?.value
                }}</span>
              </ng-template>
              <app-error-field
                [displayError]="
                  personalDataForm
                    .get('postOfficeAddress')!
                    .hasError('maxlength')
                "
                [errorMessage]="'Max field length = 100'"
              ></app-error-field>
            </div>
          </div>
          <ng-container formGroupName="contactPerson">
            <div class="form__item row">
              <label
                class="label-input col-5"
                appMarkAsterisk
                [formGroup]="contactPerson"
                [controlName]="'name'"
                [touched]="contactPerson.get('name')!.touched"
                >Emergency contact person (relationship&name)</label
              >
              <div class="input__wrapper col-sm-5">
                <app-dropdown
                  [border]="isEditable ? 'classic' : 'none'"
                  [items]="relationships"
                  formControlName="relationship"
                  [isEditMode]="isEditable"
                ></app-dropdown>
                <input
                  type="text"
                  class="input__basic ml-16"
                  placeholder=" "
                  formControlName="name"
                />
                <app-error-field
                  [displayError]="
                    contactPerson.get('name')!.hasError('maxlength')
                  "
                  [errorMessage]="'Max field length = 40'"
                ></app-error-field>
              </div>
            </div>

            <div class="form__item row">
              <label class="label-input col-5" for=""
                >Emergency contact person phone number</label
              >
              <div class="input__wrapper col-sm-3">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="phoneNumber"
                  [mask]="phoneMask"
                  [patterns]="phonePatterns"
                />
              </div>
            </div>
          </ng-container>
          <div class="form__item row">
            <label class="label-input col-5" for="maritalStatus"
              >Is insuarance aplied</label
            >
            <div class="dropdown__wrapper col-sm-3">
              <app-dropdown
                ngDefaultControl
                [items]="yesNoDropdown"
                formControlName="insurence"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
            </div>
          </div>

          <div class="form__item row">
            <label class="label-input col-5" for="">T-shirt size</label>
            <div class="dropdown__wrapper col-sm-3">
              <app-dropdown
                ngDefaultControl
                formControlName="tShirtClothesSize"
                [items]="clothesSize"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
            </div>
          </div>
          <div class="form__item row">
            <label class="label-input col-5" for="">Hoddie size</label>
            <div class="dropdown__wrapper col-sm-3">
              <app-dropdown
                ngDefaultControl
                formControlName="hoodieClothesSize"
                [items]="clothesSize"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
            </div>
          </div>
        </div>

        <div class="form__col col-4">
          <div class="form__item row">
            <label class="label-input col-3" for="">Birth date</label>
            <div
              class="col-sm-4"
              [class.form__datepicker]="!isEditable"
              [class.pl-8]="!isEditable"
            >
              <app-datepicker
                ngDefaultControl
                formControlName="birthday"
                [showIcon]="isEditable"
              ></app-datepicker>
            </div>
          </div>
          <div class="form__item row">
            <label class="label-input col-3" for="maritalStatus"
              >Is maried</label
            >
            <div class="dropdown__wrapper col-sm-3">
              <app-dropdown
                formControlName="maritalStatus"
                [items]="yesNoDropdown"
                [border]="isEditable ? 'classic' : 'none'"
                [isEditMode]="isEditable"
              ></app-dropdown>
            </div>
          </div>
          <div class="form__item row">
            <label
              class="label-input col-3"
              appMarkAsterisk
              [formGroup]="personalDataForm"
              [controlName]="'childrenCount'"
              [touched]="children!.touched"
              >Children count
            </label>
            <div class="child__input form__validation col-3">
              <input
                type="number"
                inputmode="numeric"
                placeholder=" "
                class="input__basic"
                formControlName="childrenCount"
              />
              <app-error-field
                [displayError]="
                  isFieldInvalid('childrenCount', personalDataForm) &&
                  children.hasError('required')
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>

              <app-error-field
                [displayError]="
                  isFieldInvalid('childrenCount', personalDataForm) &&
                  children.hasError('min')
                "
                [errorMessage]="'Value should be positive'"
              ></app-error-field>

              <app-error-field
                [displayError]="
                  isFieldInvalid('childrenCount', personalDataForm) &&
                  children.hasError('pattern')
                "
                [errorMessage]="'Only whole numbers accepted'"
              ></app-error-field>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
  <button
    class="button button__save profile__button"
    *ngIf="isEditable"
    (click)="save()"
    #saveButton
  >
    Save
  </button>
</div>
